<template>
    <div class="rutube-player">
      <iframe
        ref="iframe"
        :src="videoSrc"
        width="720"
        height="405"
        allowfullscreen
        frameborder="0"
        style="width: 100%; height: auto;"
        >
    </iframe>
    </div>
  </template>
  
  <script>
  export default {
    name: 'RutubePlayer',
    props: {
      videoId: {
        type: String,
        required: true
      }
    },
    computed: {
      videoSrc() {
        return `https://rutube.ru/play/embed/${this.videoId}`;
      }
    },
    mounted() {
      this.updateIframeSize();
      window.addEventListener('resize', this.updateIframeSize);
    },
    unmounted() {
      window.removeEventListener('resize', this.updateIframeSize);
    },
    methods: {
      updateIframeSize() {
        const rutubePlayer = document.querySelector('.rutube-player')
        const containerWidth = Math.min(rutubePlayer.clientWidth, 720);
        // const containerWidth = Math.min(document.body.clientWidth, 720);
        const aspectRatio = 720 / 405;
        const height = containerWidth / aspectRatio;
        this.$refs.iframe.style.height = `${height}px`;
      }
    }
  };
  </script>
  
  <style scoped>
  .rutube-player {
    position: relative;
    width: 100%;
    max-width: 720px;
    margin: 0 auto;
  }
  
  /* iframe {
    width: 100%;
    height: 100%;
    min-height: 405px;
  } */
  </style>